import {normalizeItemCategory} from './itemCategoryNormalize'

/**
 * Filter catalog items by sub-filter slug (matches `filtersByCategory` / chip `filter` values).
 * @param {Array<{ category?: unknown }>} items - Already env-filtered and deduped if applicable
 * @param {string} [filter] - Chip slug or `'all'`
 * @returns {Array}
 */
export function filterCatalogItemsBySubFilter(items, filter) {
  if (!Array.isArray(items)) return []
  if (filter === 'all' || filter == null || filter === '') {
    return items
  }
  const f = normalizeItemCategory(filter) || String(filter).trim().toLowerCase()
  return items.filter((item) => {
    const cat = normalizeItemCategory(item.category)
    return cat != null && cat === f
  })
}
